import React from 'react';
import PropTypes from 'prop-types';
import ConfigurableCallWidget from './ConfigurableCallWidget';
import { chooseConfig } from 'flow/utils/call-widget-utils';

const CallWidget = ({
    discriminator,
    present,
    missing,
    variables,
    darkMode,
    width,
}) => {
    const config = chooseConfig(discriminator, variables, present, missing);

    return (
        <ConfigurableCallWidget
            config={config}
            variables={variables}
            darkMode={darkMode}
            width={width}
        />
    );
};

CallWidget.defaultProps = {
    darkMode: true,
};

CallWidget.propTypes = {
    discriminator: PropTypes.string,
    present: PropTypes.shape({
        ...ConfigurableCallWidget.propTypes,
    }),
    missing: PropTypes.shape({
        ...ConfigurableCallWidget.propTypes,
    }),
    variables: PropTypes.object, // eslint-disable-line
    darkMode: PropTypes.bool,
    width: PropTypes.number,
};

export default React.memo(CallWidget);
